import Lookup from 'src/componentes/select2';

const StatusRiscoPontoControleRevisao = (props) => {
  return (
    <Lookup
      disabled={
        props.disabled === null || props.disabled === undefined
          ? false
          : props.disabled
      }
      labelKey="descricao"
      valueKey="id"
      url="/StatusPontoControleRevisaoLookup"
      {...props}
    />
  );
};

export default StatusRiscoPontoControleRevisao;
